// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTextField-VeloTextFieldSkeleton_cls1__p0Hba","cls2":"VeloTextField-VeloTextFieldSkeleton_cls2__IeaMT VeloTextField-VeloTextFieldSkeleton_cls1__p0Hba"};